import { render, staticRenderFns } from "./BranchesAddView.vue?vue&type=template&id=2c824d53&scoped=true&"
import script from "./BranchesAddView.vue?vue&type=script&lang=js&"
export * from "./BranchesAddView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c824d53",
  null
  
)

export default component.exports